import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const CLONE_FORM_REQUEST = 'CLONE_FORM_REQUEST';
export const CLONE_FORM_SUCCESS = 'CLONE_FORM_SUCCESS';
export const CLONE_FORM_FAILURE = 'CLONE_FORM_FAILURE';

function request() {
  return {
    type: CLONE_FORM_REQUEST
  };
}

function receive() {
  return {
    type: CLONE_FORM_SUCCESS
  };
}

function reject() {
  return {
    type: CLONE_FORM_FAILURE
  };
}

export function cloneForm(formId, sourceCustomerId, sourceAccountId, customerId, accountId, onSuccess) {
  return (dispatch) => {
    dispatch(request(formId));

    const promise = () => ApiService
      .cloneForm(formId, sourceCustomerId, sourceAccountId, customerId, accountId)
      .then((response) => {
        dispatch(receive());
        toastr.success('Success', 'Form cloned successfully');
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
